import { lazy } from 'react'

import generateRouterDetail from 'utils/helpers/generateRouterDetail'
import {
  MPStaffRBAC,
  MPStaffBulkUploadRBAC,
  MPHiringFunnelRBAC,
  PrioritizationSettingRBAC,
  BulkUploadRBAC,
  MPStaffUpsertDetailsRBAC,
} from './rbac'

const MPStaff = lazy(() => import('../pages/MPStaff'))
const MassUpload = lazy(() => import('pages/MassUpload'))
const MPHiringFunnel = lazy(() => import('../pages/MPHiringFunnel/HiringFunnel'))
const PrioritizationSetting = lazy(() => import('../pages/MPHiringFunnel/PrioritizationSetting'))
const ManPowerBulkUpload = lazy(() => import('features/Enterprise/HRIS/pages/ManPowerBulkUpload'))
const MpStaffUpsertDetails = lazy(() => import('../pages/MpStaffUpsertDetails'))

export const MPStaffRouter: RouterFeatureInterface<'MPStaffRouter', '/dashboard/mp-staff'> = {
  name: 'MPStaffRouter',
  Component: MPStaff,
  path: '/dashboard/mp-staff',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MPStaffRBAC.pageID,
}

export const MPStaffUpsertCreateRouter: RouterFeatureInterface<
  'MPStaffUpsertCreateRouter',
  '/dashboard/mp-staff/create'
> = {
  name: 'MPStaffUpsertCreateRouter',
  Component: MpStaffUpsertDetails,
  path: '/dashboard/mp-staff/create',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MPStaffUpsertDetailsRBAC.pageID,
}

export const MPStaffUpsertEditDetailsRouter: RouterFeatureInterface<
  'MPStaffUpsertEditDetailsRouter',
  '/dashboard/mp-staff/edit-details/:id'
> = {
  name: 'MPStaffUpsertEditDetailsRouter',
  Component: MpStaffUpsertDetails,
  path: '/dashboard/mp-staff/edit-details/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MPStaffUpsertDetailsRBAC.pageID,
}

export const MPStaffBulkUploadRouter: RouterFeatureInterface<
  'MPStaffBulkUploadRouter',
  '/dashboard/mp-staff/bulk-upload'
> = {
  name: 'MPStaffBulkUploadRouter',
  Component: MassUpload,
  path: '/dashboard/mp-staff/bulk-upload',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MPStaffBulkUploadRBAC.pageID,
}

export const MPHiringFunnelRouter: RouterFeatureInterface<
  'MPHiringFunnelRouter',
  '/dashboard/mp-hiring-funnel'
> = {
  name: 'MPHiringFunnelRouter',
  Component: MPHiringFunnel,
  path: '/dashboard/mp-hiring-funnel',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MPHiringFunnelRBAC.pageID,
}

export const PrioritizationSettingRouter: RouterFeatureInterface<
  'PrioritizationSettingRouter',
  '/dashboard/mp-hiring-funnel/prioritization-setting'
> = {
  name: 'PrioritizationSettingRouter',
  Component: PrioritizationSetting,
  path: '/dashboard/mp-hiring-funnel/prioritization-setting',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: PrioritizationSettingRBAC.pageID,
}

export const HiringFunnelBulkUploadRouter: RouterFeatureInterface<
  'HiringFunnelBulkUploadRouter',
  '/dashboard/mp-hiring-funnel/bulk-upload'
> = {
  name: 'HiringFunnelBulkUploadRouter',
  Component: () => <ManPowerBulkUpload type="hiringFunnel" />,
  path: '/dashboard/mp-hiring-funnel/bulk-upload',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: BulkUploadRBAC.pageID,
}

export const JobIdBulkUploadRouter: RouterFeatureInterface<
  'JobIdBulkUploadRouter',
  '/dashboard/mp-hiring-funnel/bulk-upload-job-request'
> = {
  name: 'JobIdBulkUploadRouter',
  Component: () => <ManPowerBulkUpload type="jobRequest" />,
  path: '/dashboard/mp-hiring-funnel/bulk-upload-job-request',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: BulkUploadRBAC.pageID,
}

const HRISAccountRouter = [
  MPStaffRouter,
  MPStaffUpsertCreateRouter,
  MPStaffUpsertEditDetailsRouter,
  MPStaffBulkUploadRouter,
  MPHiringFunnelRouter,
  PrioritizationSettingRouter,
  HiringFunnelBulkUploadRouter,
  JobIdBulkUploadRouter,
]

export const HRISAccountRouterDetail = generateRouterDetail(HRISAccountRouter)

export default HRISAccountRouter
